import ClusterStyleTypeUtil from "./ClusterStyleTypeUtil";
import LineStyleTypeUtil from "./LineStyleTypeUtil";
import PolygonStyleTypeUtil from "./PolygonStyleTypeUtil";
import SymbolAndPolygonStyleTypeUtil from "./SymbolAndPolygonStyleTypeUtil";
import SymbolBadgeStyleTypeUtil from "./SymbolBadgeStyleTypeUtil";
import SymbolStyleTypeUtil from "./SymbolStyleTypeUtil";
import TextOnlyStyleTypeUtil from "./TextOnlyStyleTypeUtil";

export default class StyleTypesUtil {
    ClusterStyle: ClusterStyleTypeUtil;
    LineStyle: LineStyleTypeUtil;
    PolygonStyle: PolygonStyleTypeUtil;
    SymbolAndPolygonStyle: SymbolAndPolygonStyleTypeUtil;
    SymbolBadgeStyle: SymbolBadgeStyleTypeUtil;
    SymbolStyle: SymbolStyleTypeUtil;
    TextOnlyStyle: TextOnlyStyleTypeUtil;

    constructor() {
        const symbolStyle = new SymbolStyleTypeUtil();

        this.ClusterStyle = new ClusterStyleTypeUtil(symbolStyle);
        this.LineStyle = new LineStyleTypeUtil(symbolStyle);
        this.PolygonStyle = new PolygonStyleTypeUtil();
        this.SymbolAndPolygonStyle = new SymbolAndPolygonStyleTypeUtil(this);
        this.SymbolBadgeStyle = new SymbolBadgeStyleTypeUtil(symbolStyle);
        this.SymbolStyle = symbolStyle;
        this.TextOnlyStyle = new TextOnlyStyleTypeUtil();
    }
}
